export default __webpack_public_path__ + "static/media/Confectionery3.57369bcb.png";